import { useCallPrefs } from '@/hooks/calls/useCallPrefs';
import { SonaxHeaderButton } from './SonaxHeaderButton';
import { SoftphoneDialPopover } from './SoftphoneDialPopover';

/**
 * Roteia o botão de telefone do header conforme a preferência do usuário.
 *
 * Feito por composição, sem tocar no SonaxHeaderButton: aquele componente é frágil
 * (intervals de reposicionamento, flags em window, armSonax/disarmSonax) e qualquer
 * alteração ali arrisca o webphone de quem não pediu mudança nenhuma.
 *
 * Enquanto as prefs carregam, `provider` já vem como 'webphone' (default do hook),
 * então o header renderiza igual ao de hoje — e o SonaxHeaderButton continua devolvendo
 * null para quem não tem script.
 */
export function HeaderCallButton() {
  const { provider } = useCallPrefs();
  return provider === 'softphone' ? <SoftphoneDialPopover /> : <SonaxHeaderButton />;
}
